import { fetch } from '@/utils/http'

export default {
  //获取SPV轻节点列表
  getList: params => fetch('get', '/cbaas-service/v1/spv/list', params), //SPV轻节点列表
  createSpvNode: params => fetch('post', '/cbaas-service/v1/spv/create', params), //创建spv节点
  subscribeSpvNode: params => fetch('post', '/cbaas-service/v1/spv/subscribe', params), //订阅spv节点
  deleteSpvNode: params => fetch('post', '/cbaas-service/v1/spv/delete', params), //订阅spv节点
  downloadSpvConfig: params => fetch('get', `/cbaas-service/v1/spv/download?spvId=${params.spvId}`, params), //下载spv节点配置
  deliver: params => fetch('post', '/cbaas-service/v1/spv/deliver', params) //调用spv服务
}
